import getMonthShortLabel from './getMonthShortLabel';
import type { BuildMonthPickerGridParams, MonthPickerCell } from '../types';

const buildMonthPickerGrid = ({
    year,
    selectedMonth,
    currentMonth,
    earliestMonth,
}: BuildMonthPickerGridParams): MonthPickerCell[] =>
    Array.from({ length: 12 }, (_value, monthIndex) => {
        const monthKey = `${year}-${String(monthIndex + 1).padStart(2, '0')}`;

        return {
            monthKey,
            label: getMonthShortLabel({ monthIndex }),
            isSelected: monthKey === selectedMonth,
            isDisabled: monthKey < earliestMonth || monthKey > currentMonth,
        };
    });

export default buildMonthPickerGrid;
